import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AppRoute from "../../routes/route";
import Container from "../Container/Container";
import { funcSetAccessToken } from "../../store/actions/TokenActions";
//import { GetTokenCookie } from "../../shared/SharedUtility";
import GlobalService from "../../services/GlobalService";
import { LoaderEle } from "../../shared/SharedUtility";
import Popup from '../sharedUI/popup/index';
import { StartIdleTimer, loadPartnerTheme } from '../../shared/SharedUtility';
import errorHandler from "../../shared/ErrorHandler";
import Cookies from 'js-cookie';
import { isPartnersWithCustomTheme, getPartnerName } from '../../shared/PartnerUtility';
import { funcPartnerThemeData } from "../../store/actions/MasterDataActions";
export const Main = () => {
  const dispatch = useDispatch();
  const [oAuthRes, setOAuthRes] = useState(false);
  const userDetail = useSelector((state) => state.User.UserDetail);
  const [showPopup, setShowPopup] = useState(false);
  const [counter, setCounter] = useState(10);
  const setAccessToken = (passPharse, userDetail,oauthPayload,partner) => {
    //const oAuth = GetTokenCookie();
    //if (oAuth) {
    //  GlobalService.setOAuthToken(oAuth);
    //}
    //else {
    dispatch(funcSetAccessToken(passPharse, userDetail,oauthPayload,partner));
    //}
  }
  const appTheme = useSelector((state) => state.MasterData.appTheme);
  useEffect(() => {
    StartIdleTimer((TOTALTIME, TIMEELAPSED) => {
      if (TOTALTIME - TIMEELAPSED <= 10) {
        setShowPopup(true)
        if (counter > 0)
          setCounter(counter => counter - 1);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   const queryString = window.location.search;
  //   const searchParams = new URLSearchParams(queryString);
  //   const currentPath = window.location.pathname.split("/");
  //   if (window.document.referrer.indexOf("localhost:8001") > 0 || window.document.referrer.indexOf("digitallocker.gov.in") > 0) {
  //     console.log("document.referrer", window.document.referrer);
  //   } else {
  //     if (!currentPath[2] && !queryString) {
  //       if (eApplyCookie && eApplyCookie?.hsToken){
  //         setAccessToken("elite", userDetail);
  //       }else{
  //         setOAuthRes(true);
  //       }
  //     } else {
  //       //currentPath[2] is not null  here 
  //       const track = searchParams.get("track");
  //       const retrive = searchParams.get("retrieve");
  //       const debit = searchParams.get("debit");
  //       let partner = searchParams.get("partner");
  //       let passPhrase = "";
  //       if (partner) {
  //         let accessToken = Cookies.get("sprint-access-token");
  //         let CookieData = Cookies.get("partner-Data");
  //         let partnerData = CookieData.split('|');
  //         let visitorId = partnerData[1]
  //         if(accessToken){
  //           let oauthPayload = {
  //             accessToken: accessToken,
  //             cookie: Cookies.get("x-sbic-user-fgp"),
  //             clientIPAddress: Cookies.get("clientIPAddress"),
  //             visitorId: visitorId
  //           }
  //           setAccessToken("","",oauthPayload,partner);
  //       }
  //       }
  //        if (track)
  //         passPhrase = track.substring(0, 10);
  //       else if (retrive)
  //         passPhrase = retrive.substring(0, 10);
  //       else if (debit) 
  //         passPhrase = localStorage.getItem("cardTypeLocal");
        
  //       if (track || retrive || debit)
  //        setAccessToken(passPhrase, userDetail);
  //       else if (currentPath[2] && eApplyCookie && eApplyCookie?.hsToken)
  //         setAccessToken(currentPath[2], userDetail);
  //       else if (currentPath[2])
  //         setOAuthRes(true);
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    dispatch(funcPartnerThemeData())
    const queryString = window.location.search;
    const searchParams = new URLSearchParams(queryString);
    const currentPath = window.location.pathname.split("/");
    if (window.document.referrer.indexOf("localhost:8001") > 0 || window.document.referrer.indexOf("digitallocker.gov.in") > 0) {
     // console.log("document.referrer", window.document.referrer);
    } else {
      
      if (!currentPath[2] && !queryString) {
        setAccessToken("elite", userDetail);
      } else {
        const track = searchParams.get("track");
        const retrive = searchParams.get("retrieve");
        const debit = searchParams.get("debit");
        const finarkien = searchParams.get("consentStatus");
        let hyperverge="";
        let perfiosRedirectSts="";
        if(searchParams.get('transactionId') && searchParams.get('status')){
           perfiosRedirectSts = searchParams.get('status')?.toUpperCase();
        } else if(searchParams.get('status')?.toUpperCase()){
           hyperverge = searchParams.get('status')?.toUpperCase();
        } 
        const ekycStatus = searchParams.get('ekycResponse');
        let partner = searchParams.get("partner");
        if (partner) {
          let accessToken = Cookies.get("sprint-access-token");
          let CookieData = Cookies.get("partner-Data");
          localStorage.setItem("partnerRedirect", partner);
          let partnerData = CookieData.split('|');
          let visitorId = partnerData[1]
          if(accessToken){
            let oauthPayload = {
              accessToken: accessToken,
              cookie: Cookies.get("x-sbic-user-fgp"),
              clientIPAddress: Cookies.get("clientIPAddress"),
              visitorId: visitorId
            }
            setAccessToken("","",oauthPayload,partner);
          }
        }
        else{
          
          let passPhrase = "";
          if (currentPath[2])
            passPhrase = currentPath[2];
          else if (track)
            passPhrase = track.substring(0, 10);
          else if (retrive)
            passPhrase = retrive.substring(0, 10);
          else if (debit || hyperverge || finarkien || perfiosRedirectSts || ekycStatus) {
            passPhrase = localStorage.getItem("cardTypeLocal");
          }
          const partnerCookieData = Cookies.get('partner-Data');
          if (!partnerCookieData && !debit && !hyperverge && !finarkien && !perfiosRedirectSts && !ekycStatus) {
           localStorage.removeItem("partnerRedirect");
          } 
        
          setAccessToken(passPhrase, userDetail);
       }
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
      var timeInt = setInterval(function () {
        if (GlobalService.getOAuthToken()) {
          setOAuthRes(true);
          clearInterval(timeInt);
        }
      }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const partner = getPartnerName();
    //if (partner && partner!==null && isPartnersWithCustomTheme(partner) && appTheme !== null){
    if (appTheme !== null){
      loadPartnerTheme(appTheme)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appTheme])



  return (
    <>
      {
        showPopup &&
        <Popup
          popupStyle="exitPopupStyle"
          content={
            <>
              <h3>Your session is about to expire due to inactivity.</h3>
              <p>You will be redirected to Sprint Landing Page in {counter} second(s)</p>
            </>
          }
          filename={"arrow_forward_black_24dp"}
          ext={"png"}
          renditions={["2x"]}
          handleClose={() => {
            setShowPopup(false);
            setCounter(10);
          }}
          buttonLabel={"Okay"}
        />

      }
      <BrowserRouter basename={`/${process.env.REACT_APP_NAME}`}>
        <Container>
          {oAuthRes ? <AppRoute /> : LoaderEle()}
        </Container>
      </BrowserRouter>
    </>
  );
};

export default errorHandler(Main);
